import styled from "styled-components";
import { Container } from "react-bootstrap";

export default function DarkBackground({ children, style, fullWidth = false }) {
  return (
    <>
      {fullWidth ? (
        <StyledContainer fluid style={{ ...style }}>
          {children}
        </StyledContainer>
      ) : (
        <Container>
          <BackgroundContainer style={{ ...style }}>
            {children}
          </BackgroundContainer>
        </Container>
      )}
    </>
  );
}

const BackgroundContainer = styled.div`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  overflow: clip;
  background: #000000 url("/assets/img/bg/background-dark-1.webp") no-repeat
    center center / cover;
`;

const StyledContainer = styled(Container)`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  overflow: clip;
  background: #000000 url("/assets/img/bg/background-dark-1.webp") no-repeat
    center center / cover;
`;
